import { combineReducers } from "@reduxjs/toolkit";

// reducers
import mainReducer from "./main";
import uiReducers from "./ui";
import searchReducer from "./search";
import chatReducer from "./chat";
import calendarReducer from "./calendar";

const rootReducer = combineReducers({
  main: mainReducer,
  ui: uiReducers,
  search: searchReducer,
  chat: chatReducer,
  calendar: calendarReducer,
});

export default rootReducer;
